<template>
  <div class="select-subscriptions-table-container">
    <b-table-simple :sticky-header="true"
      class="table table-no-bordered gardenHelpTable w-100"
      id="subscriptionsTable"
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th sticky-column>Features</b-th>
          <b-th
            width=""
            v-for="subscription in subscriptions"
            :key="subscription.id"
          >
            {{ subscription.title }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th sticky-column></b-th>
          <b-th v-for="subscription in subscriptions" :key="subscription.id">
            {{ subscription.cost }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(benefit, index) in benefits" :key="benefit.id">
          <b-th sticky-column>{{ benefit.title }}</b-th>
          <b-td
            v-for="subscription in subscriptions"
            :key="subscription.id + index"
          >
            <!-- {{ subscription.benefits[index].is_active }} -->
            <font-awesome-icon
              icon="fa-solid fa-circle-check"
              :class="{ active: subscription.benefits[index].is_active == 1 }"
            />
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th sticky-column></b-th>
          <b-th v-for="subscription in subscriptions" :key="subscription.id">
            <b-button
              variant="garden-help-primary-light"
              class="btn-bumblebee btn-garden-help"
              @click="selectSubscription(subscription.id)"
            >
              Select
            </b-button>
          </b-th>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "WorkInfo",
  components: {},
  props: ["type", "table_class", "subscription"],
  data() {
    return {
      subscriptions: [
        {
          id: 1,
          title: "Weekly",
          cost: "$200",
          benefits: [
            { id: 1, is_active: 0 },
            { id: 2, is_active: 1 },
            { id: 3, is_active: 1 },
            { id: 4, is_active: 0 },
          ],
        },
        {
          id: 2,
          title: "Monthly",
          cost: "$700",
          benefits: [
            { id: 1, is_active: 1 },
            { id: 2, is_active: 1 },
            { id: 3, is_active: 1 },
            { id: 4, is_active: 0 },
          ],
        },
        {
          id: 3,
          title: "Annually",
          cost: "$1000",
          benefits: [
            { id: 1, is_active: 1 },
            { id: 2, is_active: 1 },
            { id: 3, is_active: 1 },
            { id: 4, is_active: 1 },
          ],
        },
      ],
      benefits: [
        {
          id: 1,
          title:
            "benfit 1 Ridiculus proin metus pulvinar feugiat nullam facilisi. Vestibulum ornare integer vulputate eros. ",
        },
        {
          id: 2,
          title:
            "benfit 2 Ridiculus proin metus pulvinar feugiat nullam facilisi. Vestibulum ornare integer vulputate eros. ",
        },
        {
          id: 3,
          title:
            "benfit 3 Ridiculus proin metus pulvinar feugiat nullam facilisi. Vestibulum ornare integer vulputate eros. ",
        },
        {
          id: 4,
          title:
            "benfit 4 Ridiculus proin metus pulvinar feugiat nullam facilisi. Vestibulum ornare integer vulputate eros. ",
        },
      ],
    };
  },
  mounted() {
    // var table = $("#subscriptionsTable").DataTable({
    //   ordering: false,
    //   paging: false,
    //   info: false,
    //   searching: false,
    //   responsive: true,
    //   columnDefs: [{ width: "70%", targets: 0 }],
    //   // fixedColumns: true,
    //   // scrollY:        "300px",
    //   //   scrollX:        true,
    //     scrollCollapse: true,
    //   // fixedColumns: {
    //   //   left: 1,
    //   // },
    //   // fixedHeader: true,
    // });
    // new $.fn.dataTable.FixedHeader(table);
  },
  computed: {
    _subscription: {
      get() {
        return this.subscription;
      },
      set(value) {
        this.$emit("update:subscription", value);
      },
    },
  },
  methods: {
    selectSubscription(id) {
      console.log("click select subscription ", id);
      this.$emit("update:subscription", id);
      this.$bvModal.hide("select-subscription-modal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/subscriptions/SelectSubscription.vue